var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAllocationChangeArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50933 25.6746C6.50933 25.6746 6.1957 45.4158 22.0309 47.9879C37.864 50.5625 53.4366 26.6331 54.8111 23.3442",
    stroke: "black",
    strokeWidth: 1.93917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7607 25.0402L55.3079 22.5303L56.5055 28.295",
    stroke: "black",
    strokeWidth: 1.93917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAllocationChangeArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/allocation-change-arrow.4765459193f397b7187f478fa92927a6.svg";